<p>help-shopify-identity-credentials works!</p>
